import { useNavigate } from '@tanstack/react-router';
import { type ReactNode } from 'react';

import { TableCell, TableRow } from '@/components/ui/Table';

import { AccountsCell } from './accounts-cell';
import { ListCell } from './list-cell';
import { PersonCell } from './person-cell';

import type { WikiPerson } from '../people-wiki.types';

export const PersonRow = ({
  person,
  connectionCell,
  trustedCell,
}: {
  person: WikiPerson;
  connectionCell: ReactNode;
  trustedCell: ReactNode;
}) => {
  const navigate = useNavigate();
  const openPerson = () =>
    navigate({ to: '/people-wiki/$personId', params: { personId: person.id } });

  return (
    <TableRow
      tabIndex={0}
      aria-label={`Open ${person.name}`}
      className="cursor-pointer border-border hover:bg-surface-hover focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-ring"
      onClick={openPerson}
      onKeyDown={(event) => {
        if (event.target !== event.currentTarget) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openPerson();
        }
      }}
    >
      <TableCell className="py-3 pl-5 pr-4">
        <PersonCell person={person} />
      </TableCell>
      <TableCell className="px-4 py-3 text-sm text-foreground-muted">
        <ListCell values={person.aliases} />
      </TableCell>
      <TableCell className="px-4 py-3 text-sm text-foreground-muted">
        <ListCell values={person.otherEmails} />
      </TableCell>
      <TableCell className="px-4 py-3">
        <AccountsCell accounts={person.accounts} />
      </TableCell>
      <TableCell className="px-4 py-3">{connectionCell}</TableCell>
      <TableCell className="py-3 pl-4 pr-5">{trustedCell}</TableCell>
    </TableRow>
  );
};
